const isMobileHeader = () => {
    return window.matchMedia('(max-width: 1199px)').matches;
}

export default isMobileHeader;